import { Routes } from '@angular/router';

import { HomeComponent } from '@src/app/home/home.component';
import { AuthGuard } from './shared/guards/auth-guard.service';
import { HeaderComponent } from './header/header.component';
import { AccountLayoutComponent } from './account-layout.component';
import { MainLayoutComponent } from './main-layout.component';
import { AccountGuard } from './shared/guards/account-guard.service';
import { Role } from './shared/Roles';
import { GuestQuestionComponent } from './guest-question/guest-question.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { VideoComponent } from './Videolayoutcomponent';
import { PrivacyPolicyComponent } from './privacyPolicy.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', component: HomeComponent},
      { path: 'guest/question', component: GuestQuestionComponent}
    ]
  },
  {
    path: 'accounts',
    component: AccountLayoutComponent,
    canActivateChild: [AccountGuard],
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
    data: { preload: true }
  },
  {
    path: 'admin',
    canActivateChild: [AuthGuard],
    canLoad: [AuthGuard],
    data: {role: Role.Admin,preload:true},
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'mentor',
    canActivateChild: [AuthGuard],
    data: {role: Role.Mentor,preload:true},
    canLoad: [AuthGuard],
    loadChildren: () => import('./mantor/mantor.module').then(m => m.MantorModule)
  },
  {
    path: 'mentee',
    canActivateChild: [AuthGuard],
    data: {role: Role.Mentee,preload:true},
    canLoad: [AuthGuard],
    loadChildren: () => import('./mantee/mantee.module').then(m => m.ManteeModule)
  },
  {
    path: 'VideoPlayer',
    component: VideoComponent,
    children: [
      { path: '', component: VideoPlayerComponent},
    ]
  },
  {
    path: 'privacypolicy',
    component: PrivacyPolicyComponent,
    children: [
      { path: '', component: PrivacyPolicyComponent},
    ]
  },
  {
     path: '**',
     redirectTo: ''
  },

 
  

];
